<div class="terms-container ">
    <div class="logo">
        <img src="/assets/img/phoenix-logo.png" alt="phoenix" class="logo-phoenix">
    </div>
    <h1 class="terms-title">POLÍTICA DE PRIVACIDAD – PHOENIX GROUP S.A.C.</h1>

    <h2 class="terms-section-title">1. Introducción</h2>
    <p class="terms-paragraph">
        Phoenix Group S.A.C., identificada con RUC N.º 20609872463 y con domicilio en Calle 2 de Mayo N.º 516, oficina 201, distrito de Miraflores, Lima, Perú (en adelante, "Phoenix"), mantiene un firme compromiso con la protección de los datos personales y el cumplimiento de las normas aplicables, conforme a la Ley N.º 29733 – Ley de Protección de Datos Personales, su Reglamento aprobado por D.S. N.º 003-2013-JUS y demás disposiciones complementarias.
    </p>
    <p class="terms-paragraph">
        Phoenix declara que los datos personales serán tratados de manera lícita, segura, confidencial y transparente, garantizando los derechos de quienes interactúan a través de la Plataforma. Esta Política tiene por objeto explicar las condiciones bajo las cuales se recopilan, almacenan, utilizan y protegen los datos, así como los derechos que corresponden a los titulares.
    </p>
    <p class="terms-paragraph">
        Asimismo, Phoenix incorpora estándares internacionales de buenas prácticas en protección de datos personales, garantizando niveles adecuados de seguridad, proporcionalidad y transparencia en todas las operaciones de tratamiento.
    </p>

    <h2 class="terms-section-title">2. Consentimiento y aceptación</h2>
    <p class="terms-paragraph">
        Al acceder, navegar, registrarse o utilizar los servicios de la Web o de la App, el usuario declara haber leído y aceptado la presente Política, otorgando su consentimiento libre, previo, expreso, inequívoco e informado para el tratamiento de sus datos personales conforme a las finalidades aquí descritas.
    </p>
    <p class="terms-paragraph">
        Para aquellas finalidades que no resulten esenciales para el funcionamiento de la Plataforma ni para la ejecución del servicio contratado, Phoenix solicitará un consentimiento adicional, específico e independiente, el cual podrá otorgarse mediante casillas claramente identificadas y nunca pre-marcadas.
    </p>
    <p class="terms-paragraph">
        El usuario podrá revocar su consentimiento en cualquier momento, sin efectos retroactivos, mediante solicitud remitida a informes&#64;phoenix.com.pe.
    </p>

    <h2 class="terms-section-title">3. Finalidades del tratamiento</h2>
    <p class="terms-paragraph">
        Phoenix podrá recopilar y tratar los datos personales que resulten necesarios para gestionar el registro y autenticación del usuario, administrar la relación contractual, ejecutar los servicios o programas contratados, procesar pagos, emitir comprobantes electrónicos, brindar soporte técnico, atender reclamos o solicitudes y remitir información operativa vinculada al correcto funcionamiento del servicio.
    </p>
    <p class="terms-paragraph">
        También podrá llevar a cabo evaluaciones de satisfacción, análisis internos de calidad, optimización de la experiencia del usuario y mejoras continuas del funcionamiento de la Plataforma, siempre dentro de los límites permitidos por la Ley.
    </p>
    <p class="terms-paragraph">
        Cuando el tratamiento se base en la ejecución contractual o en el cumplimiento de obligaciones legales, Phoenix no requerirá un consentimiento adicional del titular, de acuerdo con lo previsto en el artículo 14 de la Ley. Sin embargo, cualquier actividad vinculada a comunicaciones comerciales, publicidad, newsletters, promociones o elaboración de perfiles requerirá un consentimiento específico y facultativo.
    </p>

    <h2 class="terms-section-title">4. Datos personales recopilados</h2>
    <p class="terms-paragraph">
        Phoenix podrá solicitar y recopilar información como nombre completo, documento de identidad, edad o rango etario, correo electrónico, teléfono, ocupación, empresa, ciudad o país de residencia, información de facturación o pago, así como datos de uso derivados de cookies, dirección IP, navegador, dispositivo, ubicación aproximada, historial y preferencias de navegación dentro de la Plataforma.
    </p>
    <p class="terms-paragraph">
        Cuando los servicios ofrecidos impliquen el eventual tratamiento de datos sensibles —como información relacionada con salud, bienestar o hábitos personales— Phoenix solicitará consentimiento expreso y, cuando corresponda, por escrito, en cumplimiento de lo dispuesto por la Ley.
    </p>

    <h2 class="terms-section-title">5. Banco de datos y seguridad de la información</h2>
    <p class="terms-paragraph">
        Los datos personales recopilados se almacenarán en el Banco de Datos "Usuarios Phoenix", inscrito ante la Autoridad Nacional de Protección de Datos Personales, y serán tratados únicamente para las finalidades establecidas en esta Política.
    </p>
    <p class="terms-paragraph">
        Phoenix adopta medidas técnicas, organizativas y legales que buscan garantizar la seguridad e integridad de la información, evitando su alteración, pérdida, acceso no autorizado o uso indebido. Si bien ningún sistema es completamente infalible, Phoenix aplica estándares alineados con buenas prácticas internacionales para mitigar riesgos.
    </p>
    <p class="terms-paragraph">
        Entre estas medidas se incluyen controles de acceso, cifrado de la información, monitoreo permanente, protocolos de continuidad operativa y procedimientos de atención frente a incidentes de seguridad, en concordancia con la Directiva de Seguridad emitida por la ANPDP.
    </p>

    <h2 class="terms-section-title">6. Encargos y transferencias de datos</h2>
    <p class="terms-paragraph">
        Phoenix podrá compartir datos personales con mentores, expertos, aliados estratégicos o proveedores tecnológicos que resulten indispensables para la prestación del servicio. Dichos terceros actuarán como encargados de tratamiento, encontrándose obligados por contrato a mantener la confidencialidad y seguridad de la información y a tratarla solo conforme a las instrucciones de Phoenix.
    </p>
    <p class="terms-paragraph">
        Asimismo, Phoenix podrá transferir datos cuando exista un mandato legal o cuando el usuario haya otorgado su consentimiento expreso para ello.
    </p>
    <p class="terms-paragraph">
        En caso los datos sean almacenados o tratados fuera del territorio peruano, Phoenix garantizará que dichos flujos cumplan con los estándares de nivel adecuado de protección exigidos por la Ley, empleando cláusulas contractuales, certificaciones o mecanismos equivalentes.
    </p>
    <p class="terms-paragraph">
        Phoenix, además, informará al titular cuando incorpore nuevos encargados de tratamiento posteriormente a la obtención del consentimiento, dando cumplimiento al artículo 18 de la Ley.
    </p>

    <h2 class="terms-section-title">7. Derechos ARCO y otros derechos</h2>
    <p class="terms-paragraph">
        El titular podrá ejercer sus derechos de Acceso, Rectificación, Cancelación y Oposición enviando una solicitud a informes&#64;phoenix.com.pe. La solicitud deberá incluir su nombre, número de documento y una descripción clara de lo requerido. Phoenix atenderá dichas solicitudes dentro de los plazos legales establecidos.
    </p>
    <p class="terms-paragraph">
        El titular también podrá ejercer su derecho a impedir el suministro de sus datos, así como oponerse al tratamiento por motivos fundados y legítimos, solicitar la supresión cuando corresponda y evitar decisiones basadas únicamente en el tratamiento automatizado de datos que le generen efectos significativos.
    </p>

    <h2 class="terms-section-title">8. Conservación de la información</h2>
    <p class="terms-paragraph">
        Phoenix conservará los datos personales únicamente durante el tiempo necesario para cumplir con las finalidades establecidas o mientras dure la relación contractual o el registro activo del usuario. Una vez concluida dicha relación, los datos serán eliminados o anonimizados, salvo cuando exista una obligación legal que exija su conservación.
    </p>
    <p class="terms-paragraph">
        Los datos utilizados para fines comerciales se conservarán únicamente mientras el usuario mantenga vigente su consentimiento, pudiendo solicitar en cualquier momento su eliminación o la suspensión de dichas comunicaciones.
    </p>

    <h2 class="terms-section-title">9. Uso de cookies y tecnologías similares</h2>
    <p class="terms-paragraph">
        La Web y la App emplean cookies y tecnologías que permiten optimizar la navegación, medir el rendimiento, analizar patrones de uso y personalizar el contenido disponible para el usuario. Es posible que algunas cookies sean proporcionadas por terceros, como Google, Meta o LinkedIn.
    </p>
    <p class="terms-paragraph">
        El usuario podrá gestionar la instalación de cookies desde su navegador o mediante los mecanismos habilitados en la Plataforma, pudiendo rechazarlas salvo aquellas que resulten estrictamente necesarias para su funcionamiento.
    </p>

    <h2 class="terms-section-title">10. Modificaciones de la Política de Privacidad</h2>
    <p class="terms-paragraph">
        Phoenix podrá actualizar esta Política cuando resulte necesario. La versión vigente será publicada en la Plataforma y entrará en vigencia desde su publicación.
    </p>
    <p class="terms-paragraph">
        En caso se introduzcan cambios sustanciales o nuevas finalidades que requieran consentimiento adicional, Phoenix notificará previamente al titular y solicitará su aceptación antes de aplicar dichas modificaciones.
    </p>

    <h2 class="terms-section-title">11. Contacto y autoridad competente</h2>
    <p class="terms-paragraph">
        Para consultas, solicitudes o el ejercicio de derechos, los usuarios pueden comunicarse a informes&#64;phoenix.com.pe.
    </p>
    <p class="terms-paragraph">
        Si consideran que no han recibido una respuesta adecuada, podrán acudir a la Autoridad Nacional de Protección de Datos Personales, ubicada en Calle Scipión Llona 350, Miraflores, Lima, Perú.
    </p>

    <h1 class="terms-title" style="margin-top: 50px;">POLÍTICA DE COOKIES – PHOENIX GROUP S.A.C.</h1>

    <h2 class="terms-section-title">1. Introducción</h2>
    <p class="terms-paragraph">
        La presente Política de Cookies explica de manera clara y transparente cómo Phoenix Group S.A.C. (en adelante, "Phoenix"), identificada con RUC N.º 20609872463 y con domicilio en Calle 2 de Mayo N.º 516, oficina 201, Miraflores, Lima, utiliza cookies y tecnologías similares en su sitio web y en la AppWeb (conjuntamente, la "Plataforma").
    </p>
    <p class="terms-paragraph">
        Phoenix emplea estas tecnologías para asegurar el funcionamiento adecuado de la Plataforma, mejorar la experiencia del usuario, analizar patrones de navegación y, con autorización del titular, personalizar contenidos o comunicar información comercial.
    </p>
    <p class="terms-paragraph">
        La instalación y uso de cookies se realiza conforme a la Ley de Protección de Datos Personales (Ley N.º 29733), su Reglamento y demás normas aplicables.
    </p>

    <h2 class="terms-section-title">2. ¿Qué son las cookies?</h2>
    <p class="terms-paragraph">
        Las cookies son pequeños archivos de texto que se almacenan en el navegador o dispositivo del usuario cuando accede a la Plataforma. Estas permiten recordar información esencial, como el inicio de sesión, preferencias de navegación o configuraciones básicas, y ayudan a que la experiencia del usuario sea más ágil y coherente.
    </p>
    <p class="terms-paragraph">
        Existen también tecnologías similares como píxeles, etiquetas, SDKs o identificadores únicos de dispositivo, que cumplen funciones asociadas al análisis de uso y personalización. A efectos de esta Política, todas ellas serán denominadas "cookies".
    </p>

    <h2 class="terms-section-title">3. ¿Cómo utiliza Phoenix las cookies?</h2>
    <p class="terms-paragraph">
        Phoenix utiliza cookies para garantizar el funcionamiento técnico indispensable de la Plataforma, facilitar la navegación, optimizar la experiencia del usuario y ofrecer servicios que respondan a los intereses y preferencias del titular.
    </p>
    <p class="terms-paragraph">
        De manera general, las cookies permiten:
    </p>
    <p class="terms-paragraph">
        • Mantener sesiones activas sin necesidad de ingresar credenciales repetidamente.
    </p>
    <p class="terms-paragraph">
        • Recordar configuraciones o preferencias del usuario.
    </p>
    <p class="terms-paragraph">
        • Analizar la forma en que se navega para identificar mejoras.
    </p>
    <p class="terms-paragraph">
        • Gestionar funcionalidades audiovisuales y de interacción.
    </p>
    <p class="terms-paragraph">
        • Facilitar la seguridad y detección de comportamientos inusuales.
    </p>
    <p class="terms-paragraph">
        • Permitir —solo con consentimiento— la entrega de comunicaciones personalizadas o anuncios ajustados al perfil del usuario.
    </p>

    <h2 class="terms-section-title">4. Tipos de cookies utilizadas en la Plataforma</h2>
    <p class="terms-paragraph">
        Para simplificar la comprensión, Phoenix agrupa las cookies en categorías funcionales, aunque algunas puedan situarse en más de un tipo según su propósito.
    </p>

    <h3 class="terms-subsection-title">Cookies estrictamente necesarias</h3>
    <p class="terms-paragraph">
        Son esenciales para el funcionamiento de la Plataforma y para la prestación del servicio solicitado por el usuario. Permiten la navegación, la autenticación, el uso seguro de funciones básicas y la gestión de sesiones. Sin estas cookies, la Plataforma no puede operar correctamente.
    </p>
    <p class="terms-paragraph">
        Estas cookies no requieren consentimiento, pues se basan en la ejecución del servicio digital solicitado por el usuario.
    </p>

    <h3 class="terms-subsection-title">Cookies de rendimiento, análisis o medición</h3>
    <p class="terms-paragraph">
        Ayudan a comprender cómo los usuarios interactúan con la Plataforma, qué secciones visitan con mayor frecuencia, cuánto tiempo permanecen en ellas y qué errores se pueden presentar. Esta información permite mejorar la calidad, estabilidad y eficiencia del servicio.
    </p>
    <p class="terms-paragraph">
        Phoenix utiliza, cuando corresponde, herramientas de terceros como Google Analytics u otras plataformas de medición, siempre aplicando configuraciones que respeten la anonimización o la disociación cuando ello sea posible.
    </p>

    <h3 class="terms-subsection-title">Cookies de personalización o experiencia</h3>
    <p class="terms-paragraph">
        Permiten recordar preferencias específicas del usuario, como idioma, zona horaria o ajustes visuales, contribuyendo a una navegación más cómoda y adaptada.
    </p>
    <p class="terms-paragraph">
        Estas cookies pueden requerir consentimiento cuando su uso no sea estrictamente necesario para el funcionamiento básico de la Plataforma.
    </p>

    <h3 class="terms-subsection-title">Cookies de marketing o publicidad</h3>
    <p class="terms-paragraph">
        Se utilizan, con autorización del titular, para mostrar contenidos y comunicaciones que puedan ajustarse a sus intereses. Suelen provenir de terceros como Meta, Google o plataformas de anuncios digitales.
    </p>
    <p class="terms-paragraph">
        Estas cookies permiten medir la eficacia de campañas promocionales y elaborar segmentos o audiencias basados en intereses.
    </p>
    <p class="terms-paragraph">
        Su instalación requiere consentimiento previo, libre, expreso e inequívoco, y el usuario puede retirarlo en cualquier momento.
    </p>

    <h2 class="terms-section-title">5. Cookies de terceros</h2>
    <p class="terms-paragraph">
        Algunas cookies no son gestionadas directamente por Phoenix, sino por proveedores tecnológicos que ofrecen servicios de medición, análisis, publicidad o funcionalidades específicas. Dichos proveedores pueden tratar datos personales conforme a sus propias políticas, aunque siempre bajo las restricciones y salvaguardas exigidas contractualmente por Phoenix.
    </p>
    <p class="terms-paragraph">
        Phoenix asegura que todo tercero que intervenga como encargado de tratamiento cumpla con medidas de seguridad adecuadas y trate la información solo bajo sus instrucciones.
    </p>

    <h2 class="terms-section-title">6. Gestión y configuración de cookies</h2>
    <p class="terms-paragraph">
        El usuario puede aceptar, rechazar o configurar las cookies en cualquier momento mediante los mecanismos habilitados por Phoenix en la Plataforma. Asimismo, la mayoría de navegadores permiten administrar manualmente la instalación de cookies, eliminarlas o bloquearlas completamente.
    </p>
    <p class="terms-paragraph">
        Sin embargo, deshabilitar algunas cookies —en especial las esenciales— puede afectar el funcionamiento adecuado de la Plataforma o impedir la utilización de ciertas funciones.
    </p>
    <p class="terms-paragraph">
        Los navegadores habituales ofrecen opciones de gestión accesibles desde sus menús de configuración; Phoenix puede brindar enlaces informativos dentro de la propia Plataforma para facilitar dicho proceso.
    </p>

    <h2 class="terms-section-title">7. Relación con la Política de Privacidad</h2>
    <p class="terms-paragraph">
        Las cookies pueden implicar el tratamiento de datos personales, tales como identificadores en línea, dirección IP, hábitos de navegación o preferencias. Cuando esto ocurre, dicho tratamiento se rige también por la Política de Privacidad de Phoenix, donde se explican en detalle las bases legales aplicables, la conservación de los datos y los derechos de los titulares.
    </p>

    <h2 class="terms-section-title">8. Conservación de las cookies</h2>
    <p class="terms-paragraph">
        La duración de una cookie puede ser temporal —eliminándose al cerrar el navegador— o persistente, permaneciendo durante un período determinado que puede variar según su función o proveedor.
    </p>
    <p class="terms-paragraph">
        Phoenix conserva cookies solo por el tiempo estrictamente necesario para las finalidades correspondientes y, en el caso de aquellas basadas en consentimiento, mientras este se mantenga vigente.
    </p>

    <h2 class="terms-section-title">9. Actualizaciones de la presente Política</h2>
    <p class="terms-paragraph">
        Phoenix podrá actualizar esta Política de Cookies para reflejar cambios tecnológicos, regulatorios o funcionales en la Plataforma. Cuando se introduzcan modificaciones sustanciales, se informará al usuario a través de los canales disponibles, incluyendo notificaciones en la propia Plataforma.
    </p>
    <p class="terms-paragraph">
        La versión vigente será aquella publicada en la Web y la AppWeb al momento de su consulta.
    </p>

    <h2 class="terms-section-title">10. Contacto</h2>
    <p class="terms-paragraph">
        Para consultas relacionadas con esta Política o con el uso de cookies en la Plataforma, el usuario puede escribir a:
    </p>
    <p class="terms-paragraph">
        informes&#64;phoenix.com.pe
    </p>

    <div class="container-button">
        <button class="boton-principal" (click)="return()">Regresar</button>
    </div>
</div>